module.exports = __webpack_public_path__ + "img/EFRAG_logo.8c3b96f8.svg";